import React from 'react';

const getPDPLink = (product) => process.env.REACT_APP_BASE_URL + product.canonical_path;

//brandOverride is assigned only for branded category pages. as single brand from brandFilter
const CategoryStructuredData = ({ categoryName, categoryUrl, products, brandOverride, brandCanonicalUrl }) => {
  if (!products?.length) return null;

  const graph = [];

  const brandId = brandOverride ? brandCanonicalUrl : null;

  if (brandOverride) {
    graph.push({
      '@type': 'Brand',
      '@id': brandId,
      name: brandOverride,
    });
  }

  const getBrandObject = (product) => {
    if (brandId)
      return {
        brand: { '@id': brandId },
      };
    if (product.brand)
      return {
        brand: {
          '@type': 'Brand',
          name: product.brand || 'Unknown Brand',
        },
      };
    return {};
  };

  graph.push({
    '@type': 'CollectionPage',
    '@id': categoryUrl,
    name: categoryName,
    url: categoryUrl,
    mainEntity: products.map((p) => ({
      '@type': 'Product',
      '@id': getPDPLink(p),
      name: p.name,
      description: p.shortDesc || '',
      image: p.images?.[0]?.url || undefined,
      ...getBrandObject(p),
      sku: p.id,
      category: p.category || 'Unknown',
      offers:
        p.offers?.map((offer) => ({
          '@type': 'Offer',
          url: offer.url,
          priceCurrency: p.currency || 'EUR',
          price: offer.price,
          availability: 'https://schema.org/InStock',
        })) || [],
    })),
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@graph': graph,
        }),
      }}
    />
  );
};

export default CategoryStructuredData;
